// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brands-list[data-v-322fef46]{position:absolute;top:0;right:0;margin:0;margin-top:2.625rem;margin-right:1rem;display:flex;list-style-type:none;flex-direction:column;--tw-bg-opacity:1;background-color:rgb(255 255 255 / var(--tw-bg-opacity));padding-left:1.25rem;padding-right:1.25rem;padding-top:0.625rem;padding-bottom:0.625rem;box-shadow:0 12px 17px 2px rgba(84,110,122,.06),0 5px 22px 4px rgba(84,110,122,.12),0 7px 8px -4px rgba(84,110,122,.2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
